/* Kaufweise <kw-recommendations> — eigenstaendiges Custom-Element fuer Seiten ohne kw-pdp.js
   (z. B. Warenkorb-Upsell). Laedt Empfehlungen async via Shopify Recommendations-API
   und tauscht den Inhalt gegen die gefetchten Karten. Selbst-guardend, damit es sich mit
   der identischen Definition in kw-pdp.js nicht in die Quere kommt. */
(function () {
  if (customElements.get('kw-recommendations')) return;
  customElements.define('kw-recommendations', class extends HTMLElement {
    connectedCallback() {
      var url = this.getAttribute('data-url');
      if (!url || this.dataset.loaded) return;
      this.dataset.loaded = '1';
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('kw-recommendations');
        if (incoming && incoming.innerHTML.trim()) {
          this.innerHTML = incoming.innerHTML;
        }
      }.bind(this)).catch(function () {});
    }
  });
})();
